import axios, { extractData } from '@atheneum/api'
import { extendObservable } from 'mobx'
import { parentAccountApi } from '@atheneum/api'

class ClientProjectsStore {
  constructor (growlStore) {
    extendObservable(this, {
      growlStore,
      page: 1,
      perPage: 10,
      clientProjects: [],  
      projects: [],  
      currentProject: {},
      numOfClientProjects: null,
      requestedExperts: null,
      autocompleteSuggestion: '',
      autocompleteResults: [],
      loading: false,
      filter: 'all'
    })
  }

  loadClientProjects = async (clientName = '') => {
    this.loading = true
    await axios.get(`${process.env.REACT_APP_CAPI_SERVICE_URL}/pending-projects?clientName=${encodeURIComponent(clientName)}`)
      .then(res => {
          const capiProjects = extractData(res)
          this.clientProjects.replace(capiProjects)
          this.numOfClientProjects = capiProjects.length
          const projects = capiProjects.slice(0, this.perPage)
          this.projects.replace(projects)
          this.autocompleteSuggestion = clientName
          this.loading = false
      })
      .catch(err => {
          this.error = err
          this.growlStore.showError(err.message)
          this.loading = false
      })
  }

  filterProjects = (e) => {
    const value = e.target.value
    this.filter = value
    const from = (this.page - 1) * this.perPage
    const to = this.page * this.perPage

    if(value !== 'all') {
      const projects = this.clientProjects.filter(project => project.status === value)
      this.numOfClientProjects = projects.length
      this.projects.replace(projects.slice(from, to))
    } else {
      this.numOfClientProjects = this.clientProjects.length
      this.projects.replace(this.clientProjects.slice(from, to))
    }
  }

  autocomplete = async (value) => {
    if (!value) return Promise.resolve([])
    const results = await parentAccountApi.getRecordsSuggestions(value, ['parentAccount'])
    this.autocompleteResults = results
  }

  changePage = page => {
    const from = (page - 1) * this.perPage
    const to = page * this.perPage
    this.page = page
    this.projects.replace(this.clientProjects.slice(from, to))
  }

  deleteProject = async (projectId) => {
    this.loading = true
    await axios.post(`${process.env.REACT_APP_CAPI_SERVICE_URL}/delete-project`, {projectId})
      .then(() => {
        let projects = this.clientProjects.filter(project => project.id !== projectId)
        this.clientProjects.replace(projects)

        if(this.filter !== 'all') {
          projects = projects.filter(project => project.status === this.filter)
        }

        const from = (this.page - 1) * this.perPage
        const to = this.page * this.perPage
        
        this.numOfClientProjects = projects.length
        this.projects.replace(projects.slice(from, to))
        this.loading = false
        this.growlStore.showSuccess('Project deleted.')
      })
      .catch(err => {
          this.error = err
          this.growlStore.showError(err.message)
          this.loading = false
      })
  }
}

export default ClientProjectsStore
